import { render, staticRenderFns } from "./JobBoardOrders.vue?vue&type=template&id=04908069&"
import script from "./JobBoardOrders.vue?vue&type=script&lang=js&"
export * from "./JobBoardOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports